import React from 'react';
import Slide from '@material-ui/core/Slide';

const SlideUp = props => <Slide direction="up" {...props} />;

export default SlideUp;
